export const INPUT_NAME_Z_INDEX = 10
export const MY_RODEO_PRODUCTS_Z_INDEX = 10
export const STICKY_PAGE_HEADER_Z_INDEX = 100
export const MODAL_Z_INDEX = 200
export const LOADING_Z_INDEX = 200
export const TOAST_Z_INDEX = 300
